
function addVerifiedBadges() {
  const reviews = document.querySelectorAll('.jdgm-rev');
  if (!reviews.length) return;

  const verifiedBadge = `<span style="display:inline-flex; margin-left: 8px; align-items: center; gap: 4px" class="verified-badge-and-text">
    <svg viewBox="0 0 24 24" aria-label="Verified purchase" role="img" style="width: 12px; height: 12px; vertical-align: middle; flex-shrink: 0;">
      <circle cx="12" cy="12" r="12" fill="#1a1a1a"/>
      <path d="M7 12.5l3.5 3.5 6.5-7" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
    </svg>
    <span style="font-style: normal; font-weight: 400; font-size: 12px; line-height: 18px; white-space: nowrap;">Verified</span>
  </span>`;

  reviews.forEach((review) => {
    const authorEl = review.querySelector('.jdgm-rev__author');
    if (!authorEl || authorEl.querySelector('.verified-badge-and-text')) return;
    authorEl.insertAdjacentHTML('beforeend', verifiedBadge);
  });
}

function transformReviewPics() {
  const picContainers = document.querySelectorAll('.jdgm-rev__pics');

  picContainers.forEach((container) => {
    if (container.dataset.picProcessed) return;
    container.dataset.picProcessed = 'true';

    const links = Array.from(container.querySelectorAll('.jdgm-rev__pic-link'));
    if (links.length <= 1) return;

    links.forEach((link, i) => {
      if (i > 0) link.style.display = 'none';
    });

    const hiddenCount = links.length - 1;

    const badge = document.createElement('span');
    badge.className = 'multi-photo-badge';
    badge.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
        <path d="m3.122 11.13 1.455-1.455 4.002 4.002 2.547-2.547 2.183 2.183V6.69H3.122v4.439Zm-.728-5.894h11.642a.727.727 0 0 1 .728.728v11.642a.727.727 0 0 1-.728.727H2.394a.727.727 0 0 1-.727-.727V5.964a.728.728 0 0 1 .727-.728Zm8.368 5.093a1.091 1.091 0 1 1 0-2.182 1.091 1.091 0 0 1 0 2.182Z"></path>
        <path d="m15.492 9.364 1.17 1.43.658-6.59L7.184 3.192l-.132 1.317H5.59l.219-2.186a.728.728 0 0 1 .796-.652l11.584 1.16a.728.728 0 0 1 .652.796L17.682 15.21a.728.728 0 0 1-.796.651l-1.394-.139V9.364Z"></path>
      </svg>
      +${hiddenCount}
    `;

    links[0].appendChild(badge);
  });
}

function processReviews() {
  addVerifiedBadges();
  transformReviewPics();
}

// Dedicated observer for load more button
function watchLoadMore() {
  let hasAutoClicked = false;

  const loadMoreObserver = new MutationObserver(() => {
    if (hasAutoClicked) return; // Only auto-click once total

    const btn = document.querySelector('.jdgm-paginate__load-more');
    if (btn) {
      hasAutoClicked = true;
      btn.click();
    }
  });

  loadMoreObserver.observe(document.body, { childList: true, subtree: true });

  // Also try immediately in case button already exists
  const btn = document.querySelector('.jdgm-paginate__load-more');
  if (btn) {
    hasAutoClicked = true;
    btn.click();
  }
}

// Wait for Judge.me container to appear in DOM first
const pageObserver = new MutationObserver((_, obs) => {
  const container = document.querySelector('.jdgm-rev-widg__reviews');

  if (container) {
    obs.disconnect();

    const reviewObserver = new MutationObserver(() => {
      processReviews();
    });

    reviewObserver.observe(container, { childList: true, subtree: true });

    // Run once immediately
    processReviews();

  }
});

pageObserver.observe(document.body, { childList: true, subtree: true });

setTimeout(() => {
  const btn = document.querySelector('.jdgm-paginate__load-more');
  console.log('load more btn:', btn);
  if (btn) {
    // Try direct click first
    console.log('load more btn:', btn);
    btn.click();

    // Also dispatch bubbling mouse event up the tree
    // btn.dispatchEvent(new MouseEvent('mousedown', { bubbles: true, cancelable: true, view: window }));
    // btn.dispatchEvent(new MouseEvent('mouseup',   { bubbles: true, cancelable: true, view: window }));
    // btn.dispatchEvent(new MouseEvent('click',     { bubbles: true, cancelable: true, view: window }));
  }
}, 6000);


